import cx from "classnames";
import { faRepeatAlt } from "@fortawesome/pro-regular-svg-icons";

import { toDollars } from "common/utils/formatting";
import Icon from "common/components/Icon";

import InlineSelect from "client/common/components/inputs/InlineSelect";

import { ProductSearchDefaultItem } from "../types";
import { getSubscriptionPrice, getSubscriptionSavingsText } from "../utils";

import styles from "../styles/ProductCardSubscriptionSelect.module.less";

type ProductCardSubscriptionSelectProps = {
  defaultItem: ProductSearchDefaultItem;
  isAddingMultipleUnits: boolean;
  disabled: boolean;
  isSubscriptionSelected: boolean;
  onChange: (isSubscriptionSelected: boolean) => void;
};

type SelectOption = "subscription" | "one-time";

const INLINE_SELECT_STYLES = {
  input: styles.options,
  option: styles.option,
  active: styles.optionSelected,
};

const ProductCardSubscriptionSelect = ({
  defaultItem,
  isAddingMultipleUnits,
  disabled,
  isSubscriptionSelected,
  onChange,
}: ProductCardSubscriptionSelectProps) => {
  const subscriptionPrice = getSubscriptionPrice(defaultItem);
  const hasSubscriptionSavings = subscriptionPrice < defaultItem.standard_price;
  const chosenOption: SelectOption = isSubscriptionSelected ? "subscription" : "one-time";
  const selectedOption = disabled ? null : chosenOption;

  return (
    <>
      <InlineSelect<SelectOption | null>
        value={selectedOption}
        onChange={(option) => onChange(option === "subscription")}
        disabled={disabled}
        styles={INLINE_SELECT_STYLES}
      >
        <InlineSelect.Option value="subscription">
          <span className={styles.optionLabel}>
            <Icon icon={faRepeatAlt} /> Autoship
          </span>
          <span className={styles.optionPriceRow}>
            <span
              className={cx(
                styles.optionPrice,
                selectedOption === "subscription" && styles.subscriptionPriceSelected,
              )}
            >
              {toDollars(subscriptionPrice)}
            </span>
            {isAddingMultipleUnits && <span className={styles.each}>each</span>}
          </span>
        </InlineSelect.Option>
        <InlineSelect.Option value="one-time">
          <span className={styles.optionLabel}>One-time</span>
          <span className={styles.optionPriceRow}>
            {defaultItem.standard_list_price > defaultItem.standard_price && (
              <span className={styles.priceWas}>{toDollars(defaultItem.standard_list_price)}</span>
            )}
            <span className={styles.optionPrice}>{toDollars(defaultItem.standard_price)}</span>
            {isAddingMultipleUnits && <span className={styles.each}>each</span>}
          </span>
        </InlineSelect.Option>
      </InlineSelect>
      {!disabled && hasSubscriptionSavings && (
        <p className={styles.savingsText}>
          {getSubscriptionSavingsText({
            oneTimePrice: defaultItem.standard_price,
            subscriptionPrice,
            isAddingMultipleUnits,
            isSubscriptionSelected,
          })}
        </p>
      )}
    </>
  );
};

export default ProductCardSubscriptionSelect;
